<template>
  <div class="c-submenu-back">
    <div class="container">
      <a class="navbar-item" @click="back">
        <span class="c-navbar-back--svg-icon">
          <base-icon width="25" height="25" name="painel/arrow-left-icon" />
        </span>
        <span>Voltar</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backRoutePath: {
      type: String,
    },
  },

  methods: {
    back() {
      if (typeof this.backRoutePath === 'string') {
        this.$router.push({ path: this.backRoutePath })
      } else {
        this.$router.back()
      }
    },
  },
}
</script>

<style lang="scss">
.c-submenu-back {
  margin-bottom: 1em;
  .container {
    display: flex;
    justify-content: left;
    a {
      color: $gray-5;

      &:hover {
        color: $support;
      }
    }
  }
}
</style>
